/*
 * Blinkpals product page script (module, loaded by blocks/bp-pdp-head.liquid).
 * The price on the Add to cart button follows the picked quantity tier (factory-qty-tiers): "Add to cart  $139".
 */

function tierPrice(scope) {
  const box = scope.querySelector('factory-qty-tiers input[type="radio"]:checked + .factory-tier__box .factory-tier__price');
  if (!box) return '';
  const node = [...box.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
  return node ? node.textContent.trim() : '';
}
function paintAtc(scope) {
  const price = tierPrice(scope);
  scope.querySelectorAll('product-form-component .add-to-cart-button').forEach((btn) => {
    if (btn.disabled) {
      btn.removeAttribute('data-bp-price');
      return;
    }
    if (price) btn.setAttribute('data-bp-price', price);
    else btn.removeAttribute('data-bp-price');
  });
}
function watchAtc() {
  document.querySelectorAll('factory-qty-tiers').forEach((tiers) => {
    const scope = tiers.closest('.shopify-section') || document;
    if (scope.dataset.bpAtc) return;
    scope.dataset.bpAtc = '1';
    paintAtc(scope);
    scope.addEventListener('change', () => requestAnimationFrame(() => paintAtc(scope)));
    new MutationObserver(() => paintAtc(scope)).observe(scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchAtc);
else watchAtc();
